module.exports = __webpack_public_path__ + "media/images/area-info1-7f83acb2.png";